import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../action';
import Validator from '../../../utils/formValidator';
import axios from 'axios';
import { api_config } from '../../../constants/api';
import { useTranslation } from 'react-i18next';
import { checkGoogleSafe } from '../../../api/apis';
import Cookies from 'js-cookie';
export default function Security() {
  let timer;
  let second = 0;
  const dispatch = useDispatch();
  const { t } = useTranslation('userLoginTips');
  const reducerData = useSelector((state) => state.userinfo);
  const { userEmail } = reducerData;
  const [loading, setLoading] = useState(false);

  const [time, setTime] = useState(0);
  const [form] = Form.useForm();
  const getCode = () => {
    let email = userEmail.email;
    let formData = new FormData();
    formData.append('email', email);
    formData.append('is_validate', 1);
    axios({
      method: 'POST',
      url: api_config.API_V2_URL + 'accounts/verification-code',
      data: formData,
    })
      .then((obj) => {
        let res = obj.data;
        if (res.code === 200) {
          message.success('It has been set to your mailbox, please check it.');
          localStorage.setItem('secTime', new Date().getTime().toString());
          waitTime();
          localStorage.setItem('emailToken', res.data.token); //保存用户的验证码token
          dispatch(action.sendVerification(res.data));
        }
      })
      .catch((err) => {
        message.error(err.response.data.msg, 1);
      });
  };

  const waitTime = () => {
    let sendTime = localStorage.getItem('secTime');
    if (sendTime == null) {
      clearInterval(timer);
    } else {
      timer = setInterval(() => {
        if (second < 0) {
          localStorage.removeItem('secTime');
          clearTimeout(timer);
          second = 0;
          setTime(second);
        } else {
          second = (
            60 -
            (new Date().getTime() - parseInt(sendTime)) / 1000
          ).toFixed(0);
          setTime(second);
        }
      }, 1000);
    }
  };
  const onFinish = (value) => {
    console.log(value);
    setLoading(true);
    checkGoogleSafe({
      email: value.email,
      code: value.verification,
      token: localStorage.getItem('emailToken'),
      id: localStorage.getItem('googleId'),
    })
      .then((obj) => {
        console.log(obj);
        if (obj.code === 200) {
          Cookies.set('authorization', obj.data.authorization, { expires: 30 });
          let hostName = window.location.hostname;
          Cookies.set('access_token', obj.data.account_access_token, {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          let expires_in = new Date().getTime() + 30 * 86400 * 1000;
          Cookies.set('access_token_expires_in', expires_in.toString(), {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          window.location.reload();
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (userEmail.email) {
      form.setFieldsValue({
        email: userEmail.email,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEmail]);

  useEffect(() => {
    waitTime();
    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const renderBtn = () => {
    return time === 0 ? (
      <span onClick={() => getCode()}>{t('GetCode')}</span>
    ) : (
      <span style={{ cursor: 'not-allowed', color: '#8372FF' }}>{time}s</span>
    );
  };
  return (
    <div className='security'>
      <div>
        <div className='loginTitle'>{t('Securityverification')}</div>
        <div className='loginSubTitle'>
          {t('youraccount')} {userEmail.email}{' '}
          {t('alreadyexiststoensurethesecuritypleaseverifyitfirst')}
        </div>
        <div>
          <Form form={form} onFinish={onFinish}>
            <Form.Item name='email' initialValue={userEmail.email}>
              <Input placeholder={t('Email')} className='inputForm' readOnly />
            </Form.Item>
            <Form.Item
              name='verification'
              validateTrigger='onBlur'
              getValueFromEvent={(e) => {
                return e.target.value.replace(/\s+/g, '');
              }}
              rules={[
                {
                  validator: Validator.emptyValidator,
                },
              ]}
            >
              <Input
                addonAfter={renderBtn()}
                className='verificationInput'
                placeholder={t('Verificationcode')}
              />
            </Form.Item>
            <Form.Item className='loginFormItem'>
              <Button
                loading={loading}
                className='loginBtn'
                type='primary'
                htmlType='submit'
              >
                {t('Confirm')}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}
